import script from "./AddUpdateGrantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateGrantModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUpdateGrantModal.vue?vue&type=style&index=0&id=ee0d1646&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee0d1646"]])

export default __exports__